<div class="p-chart-container">
  <!-- Chart -->
  <p-chart
    [type]="chartType"
    [data]="chartData"
    [options]="config">
  </p-chart>

  <!-- Legend -->
  @if (!isLoading && hasData && showLegend) {
    <!-- <div class="chart-legend-box">
      <div class="legend-grid">
        @for (dataset of chartData.datasets; track $index) {
          <div class="legend-item cursor-pointer" (click)="onLegendClick(dataset.label)">
            <span class="legend-color" [style.background-color]="dataset.borderColor" [class.dashed]="dataset.borderDash"></span>
            <span class="legend-label">{{ dataset.label }}</span>
          </div>
        }
      </div>
    </div> -->
  }

  <!-- Loading Overlay -->
  @if (isLoading) {
    <div class="loading-overlay">
      <div class="spinner"></div>
    </div>
  }

  <!-- No Data Message -->
  @if (!isLoading && !hasData) {
    <div class="no-data">
      <p>{{ noDataMessage }}</p>
    </div>
  }
</div>
